const carousels = document.querySelectorAll('.news__slider');

carousels.forEach(carousel => {
    const swiper = new Swiper(carousel, {   
        slidesPerView: 'auto',
        spaceBetween: 40,
        loop: true,
        navigation: {
            nextEl: document.querySelector('.news__slider-wrapper .news__btn-next'),
            prevEl: document.querySelector('.news__slider-wrapper .news__btn-prev'),
        },
        pagination: {
            el: carousel.querySelector('.swiper-pagination'),
            clickable: true,
        },
    });
});